import db from '../firebaseInit';
import {NOTIFICATION_SETTINGS} from './../constants/globalConstants';

const getBoardsDataFromFirebase = callbackFunc => {
  db.collection('boards')
    .get()
    .then(snapshot => {
      let boardsData = [];
      snapshot.docs.forEach(doc => {
        boardsData.push(doc.data());
      });
      callbackFunc(boardsData);
    });
};

export default getBoardsDataFromFirebase;
